module.exports = __webpack_public_path__ + "static/media/ivete_02.dfd4ec01.mp4";